import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import Table from '../../../TableResizable';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import axios from 'axios';
import { color } from '@mui/system';
import Tab1 from './Tab1';
import { Print, Save, SwipeUp, ViewAgenda, ViewColumn } from '@mui/icons-material';
import Utilisateur from '../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Data from '../../../../Data/Data.json'
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../../Functions/Security/Crypter';
import { Box, Typography, styled } from '@mui/material';
import { ColumnsType } from 'antd/es/table';
import InputForm from '../../../InputT';
import Tab2 from './Tab2';
import Amortissement from '../../../../Functions/Traitement/Amortissement';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import formatDate from '../../../../Functions/Traitement/fomatDate';
import Pret from '../../../../Models/Pret';
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import Tab3 from './Tab3';
import Tab4 from './Tab4';
import ParamsPicklist from '../../../../Types/ParamsPicklist';
import Datas from "../../../../Data/Data.json"
import Tab5 from './Tab5';
import Garantie from '../../../../Models/Garantie';
import RELATION from '../../../../Models/Relation';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import EcheanceFormat from '../../../../Models/EcheanceFormat';
import Echeance from '../../../../Models/Echeance';
import ReFormatTabAmort from '../../../../Functions/Traitement/ReFormatTabAmort';
import Tab6 from './Tab6';
//import "../../Assets/Styles/StyleForm.css";



//CreateNewCLIENT
//const Swal = require('sweetalert2');
//let LinkSourceApi= require('../../Data/Data.json');

const ValidationPret = () => {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

  // USER TOKEN
  const authHeader = useAuthHeader()

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(true)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [pageLoad, setPageLoad] = useState(true)
  const [sbmit, setSbmit] = useState("")
  const [data, setData] = useState<Pret[]>([])
  const navigate = useNavigate()
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [radioaCheck, setRadioaCheck] = useState(false)


  const ThemeTable = styled(Table)(({ theme }) => ({

    ".ant-table-body ": {
      height: '185px',
      borderBottom: '1px var(--colorOpaque020) solid',
    }

  }
  ));

  if (pageLoad) {
    setPageLoad(false)
    setLoading(true)
    setData([])

    let searchClientComptes: ParamsPicklist = { CodeAgence: user.codage, Table: "PROPOSITION_PRETS", Colonne1: "CDETAT", Colonne2: "", Init: "61", Colagence: '101', Choix: 33 }

    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.AnySearch,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherSearch': Crypter.encrypt(JSON.stringify(searchClientComptes))
      }
    };
    axios(config)
      .then((response) => {
        //alert('ok')
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;


          //alert(JSON.stringify(res))
          if (res.StatutCode == 200) {
            let datas = res.Result.Table;
            //alert(JSON.stringify(datas))

            //alert(datas.length)
            if (datas.length === 0) {
              SweetAlert.fire({ title: "Aucune demande de prêt en cour", icon: "warning" })
            }
            else {
              
              var datat: any[] = [];
              var newData: Pret[] = [];
              datas.map((data: any) => {
                //alert(data.NUMDOS+" : "+data.UTILISAI+' - '+data.AGCCPT)
                if (data.UTILISAI != user.coduti && data.UTIAPP != user.coduti && data.AGCCPT == user.codage) {
                  datat.push({
                    ...data,
                    generateNewAccount: false,
                  });
                }

              })
              datat.map((data: Pret, indice: number) => {
                newData.push({
                  key: indice,
                  NUMDOS: data.NUMDOS,
                  NUMCLI: data.NUMCLI,
                  NOMCLI: data.NOMCLI,
                  DATEDEM: data.DATEDEM,
                  TYPEPRET: data.TYPEPRET,
                  CODGES: data.CODGES,
                  CODNAE: data.CODNAE,
                  MTPRET: data.MTPRET,
                  MOTIFDEM: data.MOTIFDEM,
                  GARANTIE1: data.GARANTIE1,
                  GARANTIE2: data.GARANTIE2,
                  NOMAVAL1: data.NOMAVAL1,
                  NOMAVAL2: data.NOMAVAL2,
                  NOMAVAL3: data.NOMAVAL3,
                  COMMENT: data.COMMENT,
                  CDETAT: data.CDETAT,
                  UTILISAI: data.UTILISAI,
                  CPTENG: data.CPTENG,
                  LETAVC: data.LETAVC,
                  CPTORDI: data.CPTORDI,
                  LETCPT: data.LETCPT,
                  CPTIMP: data.CPTIMP,
                  LETIMP: data.LETIMP,
                  PERIODIC: data.PERIODIC,
                  NBRECHE: data.NBRECHE,
                  TYPCALC: data.TYPCALC,
                  TAUXEPAR: data.TAUXEPAR,
                  TYPAMORT: data.TYPAMORT,
                  TAUXINT: data.TAUXINT,
                  TAUXTAX: data.TAUXTAX,
                  DATEPEN: data.DATEPEN,
                  PRELPEN: data.PRELPEN,
                  DAT1ECHE: data.DAT1ECHE,
                  NBPERDIF: data.NBPERDIF,
                  TAUXPEN: data.TAUXPEN,
                  GESIMPAI: data.GESIMPAI,
                  DATCRE: data.DATCRE,
                  ICTPTX: data.ICTPTX,
                  TXANPR: data.TXANPR,
                  TXCOMM: data.TXCOMM,
                  DATACC: data.DATACC,
                  UTIAPP: data.UTIAPP,
                  ANNUIT: data.ANNUIT,
                  DECOUV: data.DECOUV,
                  PENALI: data.PENALI,
                  UTIVAL: data.UTIVAL,
                  IMAVIS: data.IMAVIS,
                  INTERE: data.INTERE,
                  COMMIS: data.COMMIS,
                  AGCCPT: data.AGCCPT,
                  NBMARR: data.NBMARR,
                  MTIMPA: data.MTIMPA,
                  INIMPA: data.INIMPA,
                  MTREST: data.MTREST,
                  DIFFER: data.DIFFER,
                  NBECHT: data.NBECHT,
                  CDENAE: data.CDENAE,
                  MONTAN: data.MONTAN,
                  CINTIMP: data.CINTIMP,
                  NBFPENEX: data.NBFPENEX,
                  DATECH: data.DATECH,
                  FRAIDOSSIE: data.FRAIDOSSIE,
                  CPTEPARG: data.CPTEPARG,
                  ISPAIEPARG: data.ISPAIEPARG,
                  TAUXEPARG: data.TAUXEPARG,
                  MONTEPARG: data.MONTEPARG,
                  iSEPARGDCR: data.iSEPARGDCR,
                  iSBLOQEPARG: data.iSBLOQEPARG,
                  sEXE: data.sEXE,
                  annee: data.annee,
                  heurVal: data.heurVal,
                  dateVal: data.dateVal,
                  coteprod: data.coteprod,
                  isGestCrDout: data.isGestCrDout,
                  mntRestant: data.mntRestant,
                  impaye: data.impaye,
                  nummbre: data.nummbre,
                  nommembre: data.nommembre,
                  premembre: data.premembre,
                  numidenti: data.numidenti,
                  cidentite1: data.cidentite1,
                  valgaranti: data.valgaranti,
                  designation: data.designation,
                  typcli: data.typcli,
                  libtypepret: data.libtypepret,
                  fraimember: data.fraimember,
                  libges: data.libges,
                  numcligrp: data.numcligrp,
                  montauto: data.montauto,
                  numdosmembre: data.numdosmembre,
                  fraiservi: data.fraiservi,
                  cptbloq: data.cptbloq,
                  mntdecaisse: data.mntdecaisse,
                  totdecaisse: data.totdecaisse,
                  typeDebloq: data.typeDebloq,
                  isGestAssur: data.isGestAssur,
                  txtAssur: data.txtAssur,
                  fraiDosAssur: data.fraiDosAssur,
                  cptAssur: data.cptAssur,
                  txtEmf: data.txtEmf,
                  cptEmf: data.cptEmf,
                  tvaEmf: data.tvaEmf,
                  cpttvaEmf: data.cpttvaEmf,
                  primeAssur: data.primeAssur,
                  mtFrAssur: data.mtFrAssur,
                  primeEmf: data.primeEmf,
                  mttvaemf: data.mttvaemf,
                  cptPromessOctPret: data.cptPromessOctPret,
                  cptPenImp: data.cptPenImp,
                  cptPenARecev: data.cptPenARecev,
                  cptCrDout: data.cptCrDout,
                  cptIntCrDout: data.cptIntCrDout,
                  cptImoCrDout: data.cptImoCrDout,
                  cptProvCrDout: data.cptProvCrDout,
                  jrConstatImp: data.jrConstatImp,
                  jrConstatDouteux: data.jrConstatDouteux,
                  coduti: data.coduti,
                  INTREST: data.INTREST,
                  TAXREST: data.TAXREST,
                  MNTREST: data.MNTREST,
                  MNTPAYE: data.MNTPAYE,
                  MNTIMPREST: data.MNTIMPREST,
                  iNTPAYE: data.iNTPAYE,
                  iNTIMPREST: data.iNTIMPREST,
                  tAXPAYE: data.tAXPAYE,
                  tAXIMPREST: data.tAXIMPREST,
                  cptTvaImp: data.cptTvaImp,
                  montDem: data.montDem,

                  CODOPE1: data.CODOPE1,
                  CODOPE2: data.CODOPE2,
                  CODOPE3: data.CODOPE3,
                  CODOPE4: data.CODOPE4,
                  CODOPE5: data.CODOPE5,

                  MTNCOM1: data.MTNCOM1,
                  MTNCOM2: data.MTNCOM2,
                  MTNCOM3: data.MTNCOM3,
                  MTNCOM4: data.MTNCOM4,
                  MTNCOM5: data.MTNCOM5,

                  garanties: data.garanties,
                  avaliste: data.avaliste,
                  step: Data.LocalVariable.LoanStep.Proposition,
                  //datjour: user.datjour

                  generateNewAccount: false,
                  DateVal: data.DateVal
                });
              })
              setData(newData);
            }
          }
        } else {
          alert(JSON.stringify(response))
        }

        setLoading(false)
      }).catch((error) => {
        setLoading(false)
        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
      })
  }


  const SetStart = () => {
    setSbmit("add")
    setAjoutActif(true)
    setEnregActve(false)
    setAnnulActive(false)
    setConsulActive(true)
    //form.resetFields()
  }

  try {
    let localData = JSON.parse(localStorage.getItem(Data.LocalVariable.tabAmort) + "")
    form.setFieldsValue((localData.form))

  } catch (error) {

  }

  const columns: ColumnsType<any> = [
    {
      title: 'N° Dossier',
      dataIndex: 'NUMDOS',
    },
    {
      title: 'N° Client',
      dataIndex: 'NUMCLI',
    },
    {
      title: 'Nom Client',
      dataIndex: 'NOMCLI',
    },
    {
      title: 'Date Demande',
      dataIndex: 'DATEDEM',
    },
    // {
    //   title: 'Echéancier',
    //   dataIndex: 'echeancierSansTaxe',
    // },
    {
      title: 'Type Pête',
      dataIndex: 'TYPEPRET',
    },
    {
      title: 'Code Gestionnaire',
      dataIndex: 'CODGES',
    },
    {
      title: 'Montant Proposé',
      dataIndex: 'MONTAN',
    },
    {
      title: 'Motif Demande',
      dataIndex: 'MOTIFDEM',
    }
  ];

  //  : number,
  //  : number,
  // montantTA : number,
  // echeancierPlusTA : number,
  //  : number,
  // echeancierTot : number,
  //  : Date

  useEffect(() => {
    forceUpdate({});
  }, []);

  function initialiazeButton() {
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(true)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
  }



  const SetEndStart = () => {
    SetStartForm(true);
    SeStartSearchG(false)
  }
  function handleAnulle() {
    setRadioaCheck(false)
    setImpActive(true)
    //setData([])
    form.resetFields()
    localStorage.clear()
    initialiazeButton()
    localStorage.setItem(Data.LocalVariable.reset, "1")
    localStorage.setItem(Data.LocalVariable.Mainreset, "1")
    //localStorage.setItem(Data.LocalVariable.resetTable, "1")
  }
  function cunsultButton(){
    setAnnulActive(false)
    setModifActve(false)
  }

  function modifButton() {
    setRadioaCheck(true)
    setSbmit("update")
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setConsulActive(true)
  }


  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Détaille demande
        </span>
      ),
      children: <Tab1 form={form} />, //form={form}
    },{
      key: '6',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Compte engagement relié
        </span>
      ),
      children: <Tab6 form={form} />, //form={form}
    },
    {
      key: '2',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Garanties
        </span>
      ),
      children: <Tab2 form={form} />, //form={form}
    },
    {
      key: '3',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Avalistes
        </span>
      ),
      children: <Tab3 form={form} />, //form={form}
    },
    {
      key: '4',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Commissions
        </span>
      ),
      children: <Tab4 form={form} />, //form={form}
    },
    {
      key: '5',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Tableau d'amortissement
        </span>
      ),
      children: <Tab5 form={form} />, //form={form}
    }
  ];

  const affiche = () => {
    let values: any = form.getFieldsValue()
    localStorage.clear()

    setImpActive(false)

    let Amort: Amortissement = new Amortissement(values.NUMCLI, values.PERIODIC, values.MONTEPARG, values.TAUXINT, values.NBPERDIF, values.TYPEPRET, values.TYPAMORT, values.TAUXEPAR, values.NBRECHE, values.MONTAN, values.TYPCALC, values.TAUXTAX, values.DAT1ECHE, values.cssionApliq)
    console.log(Amort)

    setData(Amort.GetAmortissement() as [])

    form.setFieldsValue(Amortissement.totaux)

  };


  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];

    errorInfo.errorFields.map((error: any) => {

      errors.push(error.name + "");
    })

    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  };


  function printTab() {
    var newData = []
    newData = data as any

    newData.push({
      "numSeq": "",
      "dateEcheacnce": "",
      "capital": "",
      "amortissement": "",
      "interet": "",
      "taxe": "",
      "epargne": "",
      "anHT": "",
      "anTTC": ""
    })
    newData.push({
      "numSeq": "TOTAL ",
      "dateEcheacnce": "",
      "capital": "",
      "amortissement": Amortissement.totaux.TotAm,
      "interet": Amortissement.totaux.TotIt,
      "taxe": Amortissement.totaux.TotTaxe,
      "epargne": Amortissement.totaux.TotEpargn,
      "anHT": Amortissement.totaux.TotAnnuite,
      "anTTC": Amortissement.totaux.TotAnTTC,
    })
    localStorage.setItem(Data.LocalVariable.tabAmort, JSON.stringify({ "columns": columns, "data": newData, "form": form.getFieldsValue() }))

    navigate("/prets/simulation/print")
  }

  const onFinish = (values: any) => {

    try {
      form.setFieldValue("generateNewAccount", localStorage.getItem("generateNewAccount"))
    } catch (error) {
      form.setFieldValue("generateNewAccount", false)
    }
    
    //alert(form.getFieldValue("generateNewAccount"))

    console.log(values)
    let num = values.NUMDOS
    SweetAlert.fire({
      title: "Voulez-vous valider le pret de\n" + values.lib_NUMCLI +"\n avec un montant de\n"+formatNumber(values.MONTAN) + " XAF ?",
      showCancelButton: true,
      color: "green",
      confirmButtonText: "Yes",
      confirmButtonColor: "green",
      cancelButtonColor: "darkred",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      icon: 'question'
    }).then((res) => {
      if (res.isConfirmed) {
        let garanties: Garantie[] = [];
        let avalistes: RELATION[] = [];
        let CodesGaranties: string[] = []
        let CodesAvalistes: string[] = []
        try {
          //console.log(localStorage.getItem(Data.LocalVariable.userDistanceHabillitation))
          garanties = JSON.parse(Crypter.decrypt(localStorage.getItem(Data.LocalVariable.garantie) + ""))
          avalistes = JSON.parse(Crypter.decrypt(localStorage.getItem(Data.LocalVariable.avaliste) + ""))

          garanties.map((g: Garantie) => {
            //alert(JSON.stringify(g))
            CodesGaranties.push(g.codgar+"|"+g.valCouvert)
          })
          avalistes.map((r: RELATION) => {
            CodesAvalistes.push(r.NumRel)
          })

          if (CodesGaranties.length != 0) {
            //alert(parseInt(form.getFieldValue("TotalMontantCouvert")))
            //let montantCouvert = JSON.parse(localStorage.getItem(Data.LocalVariable.montantGarantieCouvert)+"")
            //alert(montantCouvert)
            if (parseInt(form.getFieldValue("MONTAN")) <= parseInt(form.getFieldValue("montantGarantieCouvert"))) {
              setLoading(true);
              setIsSubmit(true)
              var pret: Pret = { "UTILISAI": user.coduti, ...values, "garanties": CodesGaranties, "avalistes": CodesAvalistes }
              pret.DATEDEM = formatDate(pret.DATEDEM)
              pret.DAT1ECHE = formatDate(pret.DAT1ECHE)
              pret.NOMCLI = values.lib_NUMCLI
              pret.CPTORDI = form.getFieldValue("CPTORDI")
              pret.CPTEPARG = form.getFieldValue("CPTEPARG")
              pret.AGCCPT = "0"+pret.CPTORDI.split('-')[1]
              pret.step = Data.LocalVariable.LoanStep.Validation
              
              pret.dateVal = formatDate(user.datjour)
              pret.DATACC = ''
              pret.UTIAPP = ''
              pret.UTIVAL = user.coduti

              let Amort: Amortissement = new Amortissement(pret.NUMCLI, pret.PERIODIC, pret.MONTEPARG, pret.TAUXINT, pret.NBPERDIF, pret.TYPEPRET, pret.TYPAMORT, pret.TAUXEPAR, pret.NBRECHE, pret.MONTAN, pret.TYPCALC, pret.TAUXTAX, ReformatDate(pret.DAT1ECHE), pret.MTNCOM1 + pret.MTNCOM2 + pret.MTNCOM3 + pret.MTNCOM4 + pret.MTNCOM5)
              
              let echeancesF : EcheanceFormat[] = Amort.GetAmortissement()
              let echeances : Echeance[] = ReFormatTabAmort(echeancesF) 
              pret.echeances = echeances
  
              console.log(JSON.stringify(echeances));
  
              let dta = Crypter.encrypt(JSON.stringify(pret));
  
              let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.CreatePret,
                headers: {
                  'Authorization': authHeader(),
                  'Content-Type': 'application/json'
                },
                data: dta,
              };
  
              axios.request(config)
                .then((response) => {
                  setLoading(false);
                  if (response.data) {
                    const res = JSON.parse(Crypter.decrypt(response.data)).Value;
  
                    if (res.StatutCode == 200) {
                      let code = pret.NUMDOS
                      form.resetFields()
                      localStorage.clear()
                      setIsSubmit(false)
                      SweetAlert.fire({ title: res.Message, icon: "success" })
                      initialiazeButton()
                      localStorage.setItem(Data.LocalVariable.reset, "1")
                      initialiazeButton()
                      setSbmit("")

                      setData(data.filter((d)=>d.NUMDOS != num))
                    }
                    else {
                      SweetAlert.fire({ title: res.Message, icon: "warning" })
                    }
                  }
                })
                .catch((error) => {
                  setLoading(false);
                  console.log(error)
                  SweetAlert.fire({ title: error, icon: "error" })
                })
            }else{
              SweetAlert.fire({ title: "La somme des montant couvert dois être supérieur ou égale au montant demandé", icon: "warning" })
            }
          }
          else {
            SweetAlert.fire({ title: "You must first select warranties of loan before to save", icon: "warning" })
          }
        } catch (error) {
          SweetAlert.fire({ title: 'Error ocured while getting warranties or avalistes' , icon: "error" })
        }
      }
    })
  };
  function modif() {
    modifButton()

  }

  // function consult() {
  //   localStorage.setItem(Data.LocalVariable.reset, "1")
  //   //let searchPret:Params={CodeAgence:'',Table: "CPRETS",Colonne1:"",Colonne2:"",Colagence:'101', Init: form.getFieldValue("NUMDOS"), Choix:3}
  //   let data = Crypter.encrypt(form.getFieldValue("NUMSIMUL"));
  //   let NUMSIMUL = form.getFieldValue("NUMSIMUL")

  //   if (data.length != 0) {
  //     initialiazeButton()
  //     setLoading(true)
  //     form.resetFields()
  //     form.setFieldValue('NUMSIMUL', NUMSIMUL)
  //     let config = {
  //       method: 'get',
  //       maxBodyLength: Infinity,
  //       url: Data.ApiUrl.GetSimulationPret,
  //       headers: {
  //         'CypherNumSimul': data,
  //         'Authorization': authHeader(),
  //         'Content-Type': 'application/json'
  //       },
  //     };
  //     axios.request(config)
  //       .then((response) => {
  //         setLoading(false);
  //         if (response.data) {
  //           const res = JSON.parse(Crypter.decrypt(response.data)).Value;

  //           console.log(res)
  //           if (res.StatutCode == 200) {
  //             form.setFieldsValue(res.Result.Table[0])
  //             form.setFieldValue('DATEDEM', ReformatDate(res.Result.Table[0].DATEDEM));
  //             form.setFieldValue('DAT1ECHE', ReformatDate(res.Result.Table[0].DAT1ECHE));
  //             //form.setFieldValue('', )

  //             localStorage.clear()

  //             //alert(JSON.stringify(res.Result.Table))

  //             initialiazeButton()

  //             cunsultButton()
  //             setEnregActve(false)


  //           }
  //           else {
  //             SweetAlert.fire({ title: res.Message, icon: "warning" })
  //           }
  //         }
  //         setLoading(false)
  //       })
  //       .catch((error) => {
  //         setLoading(false);
  //         console.log(error)
  //         SweetAlert.fire({ title: error, icon: "error" })
  //       });
  //   }
  // }

  const onSelectChange = (newSelectedRowKeys: any) => {

    console.log('selectedRowKeys changed: ', data[newSelectedRowKeys]);
    form.setFieldsValue(data[newSelectedRowKeys])
    handleDemandePret()

    setSelectedRowKeys(newSelectedRowKeys);
  }; const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };


  function handleDemandePret() {

    localStorage.setItem(Data.LocalVariable.reset, "1")
    //let searchPret:Params={CodeAgence:'',Table: "CPRETS",Colonne1:"",Colonne2:"",Colagence:'101', Init: form.getFieldValue("NUMDOS"), Choix:3}
    let data = Crypter.encrypt(form.getFieldValue("NUMDOS")+"|"+Data.LocalVariable.LoanStep.Proposition);
    let numdos = form.getFieldValue("NUMDOS")

    if (data.length != 0) {
      form.setFieldValue('garantie', '')
      form.setFieldValue('avaliste', '')
      initialiazeButton()
      setLoading(true)
      form.resetFields()
      form.setFieldValue('NUMDOS', numdos)
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetPret,
        headers: {
          'CipherNumDos': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };
      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

            console.log(res)
            if (res.StatutCode == 200) {
              form.setFieldsValue(res.Result.Table[0])
              //alert(JSON.stringify(res.Result.Table[0]))
              form.setFieldValue('DATEDEM', ReformatDate(res.Result.Table[0].DATEDEM));
              form.setFieldValue('DAT1ECHE', ReformatDate(res.Result.Table[0].DAT1ECHE));
              //form.setFieldValue('', )

              localStorage.clear()

              localStorage.setItem(Data.LocalVariable.garantie, Crypter.encrypt(JSON.stringify(res.Result.Table1)))
              localStorage.setItem(Data.LocalVariable.avaliste, Crypter.encrypt(JSON.stringify(res.Result.Table2)))
              localStorage.setItem('numcli', Crypter.encrypt(JSON.stringify(res.Result.Table[0].NUMCLI)))

              localStorage.setItem("garanties_client", Crypter.encrypt(JSON.stringify(res.Result.Table3)))
              localStorage.setItem("avalistes_client", Crypter.encrypt(JSON.stringify(res.Result.Table4)))
              localStorage.setItem("comptes_client", Crypter.encrypt(JSON.stringify(res.Result.Table5)))
              localStorage.setItem("message_comptes_client", Crypter.encrypt(JSON.stringify(res.Result.Table6)))

              var verifCptIsOk = true
              var comptesManq = ""

              for (let index = 0; index < res.Result.Table5.length; index++) {
                const element = res.Result.Table5[index];
                if (element.NUMCPT == ''){
                  verifCptIsOk = false
                  comptesManq += JSON.stringify(element)+"\n\n"
                }
              }


              //alert(JSON.stringify(res.Result.Table5))

              localStorage.setItem('load_compte', "1")

              form.setFieldValue("cssionApliq", eval(res.Result.Table[0].MTNCOM1 + res.Result.Table[0].MTNCOM2 + res.Result.Table[0].MTNCOM3 + res.Result.Table[0].MTNCOM4 + res.Result.Table[0].MTNCOM5))
              console.log(JSON.stringify(res.Result.Table))

              localStorage.setItem(Data.LocalVariable.loadPret, "1")


              initialiazeButton()

              cunsultButton()
              setEnregActve(false)

              if (!verifCptIsOk) {
                setModifActve(true)
                setEnregActve(true)
                SweetAlert.fire({ title: "Tous les comptes relatives à la mise en place du prêt n'ont pas été généré correctement. Comptes manquant : ", text: comptesManq, icon: "warning" })
              }

            }
            else {
              localStorage.removeItem(Data.LocalVariable.reset)
              SweetAlert.fire({ title: res.Message, icon: "warning" })
              setSelectedRowKeys([])
            }
          }
          setLoading(false)
        })
        .catch((error) => {
          localStorage.removeItem(Data.LocalVariable.reset)
          setLoading(false);
          console.log(error)
          SweetAlert.fire({ title: error, icon: "error" })
          setSelectedRowKeys([])
        });
    }
  }

  setTimeout(() => {
    try {
      let reset = localStorage.getItem(Data.LocalVariable.Mainreset)
      if (reset == "1") {
        setSelectedRowKeys([])
        localStorage.removeItem(Data.LocalVariable.Mainreset)
      }
    }
    catch (error) {}
  }, .1)

  return (
    <div className='tab'>
      <Typography align='center' className='formTitle'><b>VALIDATION DE PRET</b></Typography>
      <Spin spinning={loading} size='large' style={{ color: 'green' }} >
        <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>

          <div className='bG'>
            <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>
                {/* <Button size='large' className='bt_add' disabled={ajoutActve} onClick={SetStart} type="ghost" htmlType="button" block  >
                  Saisir
                </Button>
                <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block  >
                  Consulter
                </Button>
                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" onClick={affiche} block>
                  Afficher
                </Button>
                <Button size='large' className='bt_add' onClick={printTab} disabled={impActive} type="ghost" htmlType="button" block  >
                  Aperçu
                </Button> */}
                <Button size='large' className='bt_add' disabled={modifActve} onClick={modif} type="ghost" htmlType="button" block  >
                  Modifier
                </Button>
                <Button size='large' className='bt_add' onSubmit={onFinish} disabled={enregActve} type="ghost" htmlType="submit" block>
                  Valider
                </Button>
                <Button size='large' className='bt_add' disabled={true} type="ghost" htmlType="submit" block>
                  Rejetter
                </Button>
                <Button size='large' disabled={annulActive} onClick={handleAnulle} className='bt_add' type="ghost" htmlType="reset" block>
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className='clientP'>
            <div>
              <Tabs size='small' type="card" defaultActiveKey="1" items={items} />
              <Box display={"flex"} fontStyle="inherit" className='border-left tabElementAuto'>
                <Spin spinning={loading}>
                  <Form disabled={radioaCheck}>
                    <Table size='small' style={{ width: 'auto' }} rowSelection={{ ...rowSelection, type: "radio", }} columns={columns} dataSource={data} scroll={{ y: 200, x: 10 }} pagination={false} />
                  </Form>
                </Spin>
              </Box>
            </div>
            <div>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
}
export default ValidationPret;